<template>
	<div class="container">
		<div class="settlement_account card mb_0">
			<div class="d_flex justify_between">
				<h3 class="title">
					{{ $t('merchant.settlement.title') }}
				</h3>
			</div>
			<div>
				<div class="mt_20">
					<div>
						<table class="table_type mb_40">
							<colgroup>
								<col style="width: 170px" />
							</colgroup>
							<thead>
								<tr>
									<th>{{ $t('merchant.settlement.date') }}</th>
									<th>{{ $t('merchant.settlement.asset_name') }}</th>
									<th>{{ $t('merchant.settlement.account') }}</th>
									<th>{{ $t('merchant.settlement.disconnect') }}</th>
								</tr>
							</thead>
							<tbody v-if="settlementAccounts.length > 0">
								<tr v-for="item in settlementAccounts" :key="item.seq">
									<td>
										{{ $dayjs(item.regdate).format('YYYY.MM.DD') }}
									</td>
									<td>{{ item.asset_title }}</td>
									<td>{{ item.account_number }}</td>
									<td @click="deleteHandler(item.seq)" class="link_off_box">
										<span class="link_off"></span>
									</td>
								</tr>
							</tbody>
							<tbody v-else>
								<tr>
									<td colspan="4">
										{{ $t('merchant.settlement.no_content') }}
									</td>
								</tr>
							</tbody>
						</table>
						<div class="tar">
							<button
								class="button_bg_red"
								@click="settlementAccountModal = true"
							>
								{{ $t('merchant.settlement.connect') }}
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<ModalView
		add-class="merchant register tal"
		v-if="settlementAccountModal"
		@closeModal="settlementAccountModal = false"
	>
		<SettlementAccountRegister
			@closeModal="settlementAccountModal = false"
			@successRegist="successRegist"
		></SettlementAccountRegister
	></ModalView>
	<ModalMessage v-if="messageModal" @closeModal="messageModal = false">
		<div :class="'status_icon ' + modalIcon"></div>
		<p class="status_text">{{ modalStatusMessage }}</p>
		<div v-if="messageModalMode === 'success'" class="button_area">
			<button class="fc_red oneBtn" @click="messageModal = false">
				{{ $t('rtr_auth-register.confirm') }}
			</button>
		</div>
		<div v-if="messageModalMode === 'confirm'" class="button_area">
			<button @click="messageModal = false">
				{{ $t('button.cancel') }}
			</button>
			<button class="fc_red" @click="deleteSettlementAccount">
				{{ $t('merchant.settlement.disconnect') }}
			</button>
		</div>
	</ModalMessage>
</template>

<script>
import ModalView from '@/components/Layout/ModalView';
import ModalMessage from '@/components/Layout/ModalMessage';
import SettlementAccountRegister from '@/components/Merchant/Settlement/SettlementAccountRegister';
import { deleteMerchantAccount, fetchMerchantAccountList } from '@/api/pg';
import { commonError } from '@/common/dialog';
export default {
	name: 'SettlementAccount',
	components: {
		ModalView,
		ModalMessage,
		SettlementAccountRegister,
	},
	data() {
		return {
			settlementAccounts: [],
			curPage: 1,
			listCount: 10,
			settlementAccountModal: false,
			messageModal: false,
			modalIcon: '',
			modalStatusMessage: '',
			messageModalMode: '',
			deleteAccountSeq: null,
		};
	},
	created() {
		this.init();
	},
	methods: {
		init() {
			this.loadSettlementAccountList();
		},
		async loadSettlementAccountList() {
			const { data } = await fetchMerchantAccountList(
				this.$route.params.merchant_seq,
			).catch(commonError);
			this.settlementAccounts = data;
		},
		pageChangeHandler(pageNo) {
			this.curPage = pageNo;
			this.loadSettlementAccountList();
		},
		successRegist() {
			this.loadSettlementAccountList();
			this.settlementAccountModal = false;
			this.modalStatusMessage = this.$t('modal.message.settlement_connect');
			this.modalIcon = 'success';
			this.messageModalMode = 'success';
			this.messageModal = true;
		},
		deleteHandler(seq) {
			this.deleteAccountSeq = seq;
			this.modalStatusMessage = this.$t('modal.message.settlement_disconnect');
			this.modalIcon = 'information';
			this.messageModalMode = 'confirm';
			this.messageModal = true;
		},
		async deleteSettlementAccount() {
			const params = {
				merchant_seq: this.$route.params.merchant_seq,
				merchant_account_seq: this.deleteAccountSeq,
			};
			await deleteMerchantAccount(params)
				.then(() => {
					this.loadSettlementAccountList();
					this.modalStatusMessage = this.$t(
						'modal.message.settlement_disconnect2',
					);
					this.modalIcon = 'success';
					this.messageModalMode = 'success';
					this.messageModal = true;
				})
				.catch(commonError);
		},
	},
};
</script>
